export const exportCollectionToArray = (initialPayload, collection) => {
  if (initialPayload && initialPayload[collection])
    return Object.keys(initialPayload[collection]).map(
      (i) => initialPayload[collection][i]
    )
  return []
}
